import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEVersionFeatureAccess, OEVersionTargetsAlphaBetaProds, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OESportTargetType as OESportTargetType_, OESportStartSelectionContent} from './oe-sport-consts';

export const OESportTargetType = OESportTargetType_;

export const OESportTargets = new OEVersionTargetsAlphaBetaProds(
    {
        [OESportTargetType.anatomy]: [
            OETarget.sportShoulderGirdle,
            OETarget.humanThighKnee,
            OETarget.humanHip2,
            OETarget.humanElbow
        ]
    },
    {
        [OESportTargetType.anatomy]: OETarget.sportShoulderGirdle,
    },
    {
        [OESportTargetType.anatomy]: OETarget.sportShoulderGirdle,
    }
);

export const OESportFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            anatomyTargetSelection: !isLicensing,
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(licensingAccess.isValid)    {
            if(OELicensingEdition.allAbove(OELicensingEdition.basic).includes(licensingAccess.edition))  {
                featureAccess.anatomyTargetSelection = true;
            }
        }

        return featureAccess;
    }
})(OESportTargets);

export const OESportStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OESportTargets,
    OESportStartSelectionContent
);